import { render, staticRenderFns } from "./MailListAdvisor.vue?vue&type=template&id=b474f94c&scoped=true&"
import script from "./MailListAdvisor.vue?vue&type=script&lang=ts&"
export * from "./MailListAdvisor.vue?vue&type=script&lang=ts&"
import style0 from "./MailListAdvisor.vue?vue&type=style&index=0&id=b474f94c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b474f94c",
  null
  
)

export default component.exports